<template>
  <div class="filter-category">
    <div class="filters only-desktop">
      <div
        class="filter-desktop filter sz"
        @click="(e) => e.target.classList.toggle('active')"
      >
        <div class="filter-name">
          <span>{{ $t('Size') }} </span>
          <span
            v-if="selectedFiltersCount(sizeFacet) > 0"
            class="filter-count"
          >
            ({{ selectedFiltersCount(sizeFacet) }})
          </span>
        </div>
        <div class="filter-content">
          <div class="filter-content-options">
            <div
              v-for="option in sizeFacet.options"
              :key="`${sizeFacet.id}-${option.value}`"
              @click="(e) => {
                selectFilter(sizeFacet, option);
                applyFilters(selectedFiltersCopy);
                applyFiltersGtm('TAGLIA', option);
              }"
            >
              <SfFilter
                :class="{ box: true, active: isFilterSelected(sizeFacet, option) }"
                :label="option.id"
              />
            </div>
          </div>
          <p
            v-if="selectedFiltersCount(sizeFacet) > 0"
            class="filter-reset"
            @click="(e) => {
              resetFilter(sizeFacet);
            }"
          >
            {{ $t('Reset filters') }}
          </p>
        </div>
      </div>
      <div
        class="filter-desktop filter cl"
        @click="(e) => e.target.classList.toggle('active')"
      >
        <div class="filter-name">
          <span>{{ $t('Color') }}</span>
          <span
            v-if="selectedFiltersCount(colorFacet) > 0"
            class="filter-count"
          >
            ({{ selectedFiltersCount(colorFacet) }})
          </span>
        </div>
        <div class="filter-content">
          <div class="filter-content-options">
            <div
              v-for="option in colorFacet.options"
              :key="`${colorFacet.id}-${option.value}`"
              @click="(e) => {
                selectFilter(colorFacet, option);
                applyFilters(selectedFiltersCopy);
                applyFiltersGtm('COLORE', option);
              }"
            >
              <SfFilter
                :class="{
                  box: true,
                  active: isFilterSelected(colorFacet, option),
                  color: isFilterSelected(colorFacet, option)
                }"
                :selected="isFilterSelected(colorFacet,option)"
                :label="option.id"
                :color="getSfColor(option.swatch_data)"
              />
            </div>
          </div>
          <p
            v-if="selectedFiltersCount && selectedFiltersCount(colorFacet) > 0"
            class="filter-reset"
            @click="(e) => {
              resetFilter(colorFacet);
            }"
          >
            {{ $t('Reset filters') }}
          </p>
        </div>
      </div>
      <div class="filter">
        <div class="navbar__sort desktop-only">
          <p>{{ $t('Sort by') }}:</p>
          <LazyHydrate when-visible>
            <SfComponentSelect
              :value="sortBy.selected"
              class="navbar__select sf-component-select--no-chevron"
              :persistent="false"
              cancel-label=""
              :selected="sortBy.selected"
              @change="th.changeSorting"
            >
              <SfComponentSelectOption
                v-for="option in sortBy.options"
                :key="option.value"
                :value="option.value"
                class="sort-by__option"
              >
                <SfProductOption :label="$t(option.label)" />
              </SfComponentSelectOption>
            </SfComponentSelect>
          </LazyHydrate>
        </div>
      </div>
    </div>
    <SfAccordion
      open=""
      :multiple="true"
      transition=""
      show-chevron
      class="smartphone-only"
    >
      <SfAccordionItem
        :header="$t('Filters')"
        class="mobile-filter-accordion"
      >
        <div class="filter-desktop filter cl">
          <div class="filter-name">
            <span>{{ $t('Color') }}</span>
            <span
              v-if="selectedFiltersCount(colorFacet) > 0"
              class="filter-count"
            >
              ({{ selectedFiltersCount(colorFacet) }})
            </span>
          </div>
          <div class="filter-content mobile">
            <div class="filter-content-options">
              <div
                v-for="option in colorFacet.options"
                :key="`${colorFacet.id}-${option.value}`"
                @click="(e) => {
                  selectFilter(colorFacet, option);
                  applyFilters(selectedFiltersCopy);
                  applyFiltersGtm('COLORE', option);
                }"
              >
                <SfFilter
                  :class="{
                    box: true,
                    active: isFilterSelected(colorFacet, option),
                    color: isFilterSelected(colorFacet, option)
                  }"
                  :selected="isFilterSelected(colorFacet,option)"
                  :label="option.id"
                  :color="getSfColor(option.swatch_data)"
                />
              </div>
            </div>
            <p
              v-if="selectedFiltersCount(colorFacet) > 0"
              class="filter-reset"
              @click="(e) => {
                resetFilter(colorFacet);
              }"
            >
              {{ $t('Reset filters') }}
            </p>
          </div>
        </div>
        <div class="filter-desktop filter sz">
          <div class="filter-name">
            <span>{{ $t('Size') }} </span>
            <span
              v-if="selectedFiltersCount(sizeFacet) > 0"
              class="filter-count"
            >
              ({{ selectedFiltersCount(sizeFacet) }})
            </span>
          </div>
          <div class="filter-content mobile">
            <div class="filter-content-options">
              <div
                v-for="option in sizeFacet.options"
                :key="`${sizeFacet.id}-${option.value}`"
                @click="(e) => {
                  selectFilter(sizeFacet, option);
                  applyFilters(selectedFiltersCopy);
                  applyFiltersGtm('TAGLIA', option);
                }"
              >
                <SfFilter
                  :class="{ box: true, active: isFilterSelected(sizeFacet, option), isSize: true }"
                  :label="option.id"
                />
              </div>
            </div>
            <p
              v-if="selectedFiltersCount(sizeFacet) > 0"
              class="filter-reset"
              @click="(e) => {
                resetFilter(sizeFacet);
              }"
            >
              {{ $t('Reset filters') }}
            </p>
          </div>
        </div>
        <div class="filter mobile">
          <div class="navbar__sort mobile">
            <p class="sortby-mobile-title">
              {{ $t('Sort by') }}:
            </p>
            <div class="filter-radio-group">
              <SfRadio
                v-for="option in sortBy.options"
                :key="option.value"
                :name="option.value"
                :label="$t(option.label)"
                :required="false"
                :value="option.value"
                :disabled="false"
                :selected="sortBy.selected"
                @change="th.changeSorting"
              >
                <template #checkmark>
                  <div class="checkmark">
                    <nuxt-img
                      :src="require('../../assets/images/tick.svg')"
                      format="webp"
                      width="14"
                      height="10"
                      preload
                      loading="lazy"
                    />
                  </div>
                </template>
              </SfRadio>
            </div>
            <!--            <LazyHydrate when-visible>
              <SfComponentSelect
                :value="sortBy.selected"
                class="navbar__select sf-component-select&#45;&#45;no-chevron is-active"
                :persistent="false"
                cancel-label=""
                :selected="sortBy.selected"
                @change="th.changeSorting"
              >
                <SfComponentSelectOption
                  v-for="option in sortBy.options"
                  :key="option.value"
                  :value="option.value"
                  class="sort-by__option"
                >
                  <SfProductOption :label="$t(option.label)" />
                </SfComponentSelectOption>
              </SfComponentSelect>
            </LazyHydrate>-->
          </div>
        </div>
      </SfAccordionItem>
    </SfAccordion>
  </div>
</template>

<script>
import {
  SfFilter,
  SfComponentSelect,
  SfProductOption,
  SfAccordion,
  SfRadio,
} from '@storefront-ui/vue';
import LazyHydrate from 'vue-lazy-hydration';
import { defineComponent, computed, useContext } from '@nuxtjs/composition-api';
import { useVSFContext } from '@vue-storefront/core';
import { facetGetters, useFacet } from '@vue-storefront/gemini';
import { useI18n } from '~/helpers/hooks/usei18n';
import { useUiHelpers } from '~/composables';
import { getSfColor } from '~/helpers/product/productData';

export default defineComponent({
  name: 'CategoryFilter',
  components: {
    SfFilter,
    LazyHydrate,
    SfComponentSelect,
    SfProductOption,
    SfAccordion,
    SfRadio,
  },
  props: {
    categoryId: {
      type: String,
      required: true,
    },
    searchSpecsStr: {
      type: String,
      required: true,
      default() {
        return '';
      },
    },
  },
  setup(props) {
    const { searchSpecsStr } = props;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const { result } = useFacet(searchSpecsStr);
    const { app } = useContext();

    const {
      $gemini: { config: geminiConfig },
    } = useVSFContext();
    const uiHelpers = useUiHelpers();
    const trans = useI18n();
    const th = useUiHelpers();

    const getSelectedFilterValues = () => {
      const selectedFilterValues = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        (geminiConfig.facets.available)
          .map((curr) => [curr, (curr === 'price' ? '' : [])]),
      );
      const { filters } = uiHelpers.getFacetsFromURL();
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      Object.keys(filters).forEach((filter) => {
        if (filter === 'price') {
          // eslint-disable-next-line prefer-destructuring
          selectedFilterValues[filter] = filters[filter][0];
        } else {
          selectedFilterValues[filter] = filters[filter];
        }
      });
      return selectedFilterValues;
    };

    const sortBy = computed(() => facetGetters.getSortOptions(result.value));
    const facets = computed(() => facetGetters.getGrouped(result.value, geminiConfig.facets.available));
    const sizeFacet = computed(() => facets?.value?.find((i) => i.label === 'size_terms') || []);
    const colorFacet = computed(() => facets?.value?.find((i) => i.label === 'color_terms') || []);
    const selectedFilters = computed(() => getSelectedFilterValues());

    let selectedFiltersCopy = JSON.parse(JSON.stringify(selectedFilters.value));

    const isFilterSelected = (facet, option) => {
      if (facet.id === 'price') {
        return selectedFiltersCopy[facet.id];
      }

      return (selectedFiltersCopy[facet.id] || []).includes(option.value);
    };

    const selectFilter = (facet, option) => {
      if (facet.id === 'price') {
        selectedFiltersCopy[facet.id] = option.value;
        return;
      }

      if (!selectedFiltersCopy[facet.id]) {
        selectedFiltersCopy[facet.id] = [];
      }

      if (selectedFiltersCopy[facet.id].find((f) => f === option.value)) {
        selectedFiltersCopy[facet.id] = selectedFiltersCopy[
          facet.id
        ]?.filter((f) => f !== option.value);
        return;
      }
      selectedFiltersCopy[facet.id].push(option.value);
    };

    const applyFiltersGtm = (type, option) => {
      app.$gtm.push({
        event: 'filter_by',
        filter_type: type,
        filter_value: option?.attrName || '',
      });
    };

    const { changeFilters } = useUiHelpers();

    const applyFilters = (filters) => {
      if (filters) {
        selectedFiltersCopy = filters;
      }
      changeFilters(selectedFiltersCopy);
    };

    const resetFilter = (facet) => {
      selectedFiltersCopy[facet.id] = [];
      changeFilters(selectedFiltersCopy);
    };

    const selectedFiltersCount = (facet) => {
      if (selectedFiltersCopy) {
        return selectedFiltersCopy[facet.id]?.length;
      }
      return 0;
    };

    return {
      sortBy,
      trans,
      getSfColor,
      th,
      isFilterSelected,
      selectFilter,
      sizeFacet,
      colorFacet,
      applyFilters,
      selectedFiltersCount,
      resetFilter,
      applyFiltersGtm,
      selectedFiltersCopy,
      result,
      geminiConfig,
    };
  },
  mounted() {
    const fil = document.querySelectorAll('.filter-desktop');
    const filSz = document.querySelector('.filter.sz');
    const filCl = document.querySelector('.filter.cl');
    filSz.addEventListener('click', () => {
      if (filCl.classList.contains('active')) {
        filCl.classList.remove('active');
      }
    });
    filCl.addEventListener('click', () => {
      if (filSz.classList.contains('active')) {
        filSz.classList.remove('active');
      }
    });
    if (window) {
      window.addEventListener('click', (event) => {
        const evSize = event.target.matches('.filter-desktop .box');
        const evColor = event.target.matches('.filter-desktop .sf-checkbox');
        const evColorReset = event.target.matches('.filter-desktop .filter-reset');

        if (!event.target.matches('.filter-desktop') && !evSize && !evColor && !evColorReset) {
          // eslint-disable-next-line no-restricted-syntax
          for (const typeFil of fil) {
            if (typeFil.classList.contains('active')) {
              typeFil.classList.remove('active');
            }
          }
        }
      });
    }
  },
});
</script>

<style lang="scss">
.filters {
  display: flex;
  font-family: 'Spartan';
  margin: 0 -15px;

  .filter {
    margin-left: 25px;
    position: relative;
    z-index: 5;

    .navbar__sort {
      .navbar__select, p {
        display: inline-block;
      }
    }

    .sf-component-select__selected {
      position: relative;
      padding: 12px 15px;
      margin-bottom: 0;
      &:after {
        background-image: url('~@/assets/images/down-arrow.png');
        background-repeat: no-repeat;
        content: '';
        display: block;
        height: 16px;
        margin-left: 10px;
        width: 16px;
      }
    }
    .sf-component-select {
      padding-bottom: 0;
      .sf-component-select__error-message {
        display: none;
      }
    }
    .sf-component-select.is-active {
      background: #fff;
      .sf-component-select__selected:after {
        transform: rotate(180deg);
      }
    }

    .sf-component-select-option:first-child {
      border-top: 0;
    }

    .sf-component-select__dropdown {
      right: 0;
      left: auto;
      min-width: 288px;
      box-shadow: none;
    }
    .sf-component-select__dropdown {
      .sf-product-option__label {
        font-family: 'Spartan';
        font-size: 12px;
        font-weight: 500;
        line-height: 23px;
      }
    }

    .sf-product-option__label {
      color: #222a24;
      font-family: 'Spartan';
      font-size: 16px;
      font-weight: 500;
      line-height: 23px;
    }

    .filter-content .filter-relation-content {
      .relation-section {
        border-bottom: 1px solid #e9ecf1;
        padding: 15px 0;
        position: relative;

        span {
          max-width: 150px;
          word-wrap: break-word;
        }

        &:last-child {
          border: 0;
        }
      }
    }

    .filter-name {
      align-items: center;
      color: #222a24;
      display: flex;
      font-family: 'Spartan';
      font-size: 16px;
      font-weight: 500;
      line-height: 23px;
      padding: 12px 15px;
      pointer-events: none;
      text-align: right;
      &:after {
        background-image: url('~@/assets/images/down-arrow.png');
        background-repeat: no-repeat;
        content: '';
        display: block;
        height: 16px;
        margin-left: 10px;
        width: 16px;
        z-index: 222;
      }
      span {
        font-family: inherit;
        font-size: inherit;
      }
      .filter-count {
        font-size: 11px;
      }
    }
    &.active {
      .filter-name {
        background: #fff;
      }

      .filter-name:after {
        transform: rotate(180deg);
      }
    }

    &.active .filter-content {
      display: flex;
      opacity: 1;
    }
  }

  &.only-mobile {
    display: none;
  }
}

.mobile-filter-accordion {
  .sf-accordion-item__header{
    padding: 0 0 0 16px;
  }
  .sf-accordion-item__content {
    border: none;
  }
  .sf-button[aria-expanded="false"] {
    border: none;
  }
}

.filter {
  &.mobile {
    .sortby-mobile-title {
      font-size: 14px;
      line-height: 26px;
      color: #222a24;
      font-family: "Spartan";
      font-weight: 500;
    }
    .filter-radio-group {
      .sf-radio {
        .checkmark {
          visibility: hidden;
        }
        &:not(:last-child) {
          border-bottom: 1px solid #EAECF2;
        }
        &.is-active {
          background-color: #ffffff;
          .checkmark {
            visibility: visible;
            display: flex;
            align-items: center;
          }
        }
        .sf-radio__container {
          padding: 8px 0;
          flex-direction: row-reverse;
          .sf-radio__content {
            margin: 0;
            .sf-radio__label {
              margin: 0.5em 0;
              color: grey;
              font-family: "Frank Ruhl Libre", serif;
              font-weight: 400;
              white-space: normal;
            }
          }
        }
      }
    }
  }
}

.filter-content {
  background: #fff;
  display: none;
  flex-wrap: wrap;
  max-width: 420px;
  padding: 15px;
  position: absolute;
  right: 0;
  transition: opacity 0.7s;
  width: max-content;
  flex-direction: column;

  .filter-content-options {
    display: flex;
    flex-wrap: wrap;
  }

  &.relations {
    width: 100%;
  }

  .filter-relation {
    width: 100%;
  }

  &.mobile {
    display: flex;
    position: inherit;
    overflow-x: scroll;
    width: 100%;
    padding-left: 0;
    .filter-content-options {
      flex-wrap: nowrap;
      div {
        .box {
          align-items: center;
          border: 1px solid #222a24;
          display: flex;
          float: right;
          height: 34px;
          justify-content: center;
          width: 34px;
          position: relative;
          pointer-events: auto;
          overflow: hidden;
          &.is-active {
            .sf-checkbox__checkmark {
              display: none;
            }
          }
          .sf-checkbox__container {
            width: 100%;
            display: block;
            .sf-button {
              width: 100%;
              background-size: cover;
            }
            .sf-filter__label {
              top: 40%;
            }
          }
          &.is-color {
            .sf-filter__label {
              display: none;
            }
          }
          &.isSize {
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }

  .box {
    align-items: center;
    border: 1px solid #222a24;
    display: flex;
    float: right;
    height: 34px;
    justify-content: center;
    margin: 5px;
    width: 34px;
    position: relative;
    pointer-events: auto;
    overflow: hidden;
    .sf-checkbox__container {
      pointer-events: none;
    }
    .sf-filter__label {
      position: absolute;
      margin-left: 50%;
      transform: translateX(-50%);
      color: #222a24;
      font-family: 'Spartan';
      font-size: 12px;
      font-weight: 500;
      pointer-events: none;
    }
    .sf-checkbox__checkmark {
      border: none;
    }
    &:nth-child(9n + 1) {
      margin-left: 0;
    }
    &:nth-child(9n) {
      margin-right: 0;
    }
    &.active {
      background-color: #222a24;
      .color {
        background-color: #fff;
        border: 4px double #222a24;
      }
      .sf-filter__label {
        color: #fff;
      }
      span {
        color: #fff;
      }
    }

    &.active.color {
      background-color: #fff;
      border: 4px double #222a24;
      .sf-filter__label {
        color: #fff;
      }
      span {
        color: #fff;
      }
    }

    span {
      color: #222a24;
      font-family: 'Spartan';
      font-size: 12px;
      font-weight: 500;
      pointer-events: none;
    }

    &:hover {
      transform: scale(1);
    }
  }

  .filter-reset {
    font-size: 13px;
    text-decoration: underline;
    &:hover {
      cursor: pointer;
    }
  }
}

@media (max-width: 1023px) {
  .filter-color-content {
    display: block;
  }

  #category .color .sf-filter .sf-checkbox__container {
    position: relative;

    .sf-checkbox__checkmark {
      left: 0;
      position: absolute;
    }
  }
  .filter-content .box {
    height: 24px;
    width: 24px;
  }
  .filter-content .filter-size {
    .box {
      margin-top: 0;
    }
  }
  .filters {
    margin: 0;

    .filter {
      margin-left: 0;
      padding: 0;
      position: static;
      width: 100%;
      .sf-checkbox input:focus + .sf-checkbox__checkmark {
        outline: none;
      }

      .filter-name {
        padding: 15px 10px;
      }

      .filter-relation .filter-name {
        padding: 40px 10px 0;
      }

      .filter-notify {
        font-size: 11px;
        line-height: 20px;
        color: #5e6770;
        font-weight: 500;
        font-family: 'Spartan';
        padding: 10px;
        a {
          color: inherit;
          text-decoration: underline;
        }
      }

      .filter-title {
        align-items: center;
        color: #222a24;
        display: flex;
        pointer-events: none;
        position: relative;

        span {
          font-family: 'Spartan';
          font-weight: 500;
          text-transform: uppercase;
        }

        &:after {
          background-image: url('~@/assets/images/down-arrow.png');
          background-repeat: no-repeat;
          content: '';
          display: block;
          height: 16px;
          position: absolute;
          right: 0;
          width: 16px;
        }
      }
      .filter-content
      {
        flex-direction: column;
        max-width: 100%;
        width: 100%;

        .filter-content-options {
          display: flex;
          flex-wrap: wrap;
        }

        .filter-reset {
          font-size: 13px;
          text-decoration: underline;
          &:hover {
            cursor: pointer;
          }
        }

        .box {
          float: left;
          margin-right: 15px;
        }

        .filter-size-content .box {
          box-shadow: unset;
          border: 1px solid #222a24;
          height: 50px;
          width: 50px;
          pointer-events: auto;
          .sf-checkbox__checkmark {
            pointer-events: none;
          }
          .sf-checkbox__container {
            pointer-events: none;
          }

          .sf-filter__label {
            color: #222a24;
            font-size: 13px;
            pointer-events: none;
          }

          &.active {
            background: #2e3830;
            transform: scale(1);

            .sf-filter__label {
              color: #fff;
            }
          }
        }

        .filter-relation-content {
          padding: 0 10px;
          .sf-radio input:focus + .sf-radio__checkmark {
            outline-style: none;
            background-image: url('~@/assets/images/check.png');
            background-repeat: no-repeat;
            position: absolute;
            right: 15px;
            top: 50%;
            transform: translateY(-50%);
            height: 16px;
            width: 16px;
            height: 16px;
          }
          .relation-section {
            border-bottom: 1px solid #e9ecf1;
            padding: 15px 0;
            position: relative;
            .sf-radio__container {
              padding: 0;

              input {
                right: 15px;
                left: auto;
              }
              .sf-radio__checkmark {
                border: 0;
                left: auto;
                position: absolute;
                right: 15px;
              }
              .sf-radio__content {
                margin-left: 0;
                .sf-radio__label {
                  font-size: 11px;
                  font-weight: 500;
                  color: #5e6770;
                }
              }
            }

            &:last-child {
              border: 0;
            }
          }
        }

        .filter-action {
          margin: 30px 0 10px;
          padding: 0 10px;

          span {
            background: #212a24;
            color: #fff;
            display: block;
            font-family: 'Spartan';
            font-size: 10px;
            font-weight: 700;
            padding: 15px 0;
            text-align: center;
            text-transform: uppercase;
          }
        }
      }

      .filter-name span {
        font-size: 14px;
        font-weight: 500;
        color: #222a24;
      }

      .filter-name:after {
        background-image: unset;
        height: 0;
        width: 0;
      }
      &.active {
        .filter-title:after {
          transform: rotate(180deg);
        }
        .filter-content {
          display: block;
        }
      }
    }
    &.only-desktop {
      display: none;
    }
    &.only-mobile {
      display: flex;
    }
  }
}

body .size-list .size-item {
  max-width: 65px;
  width: 65px;
  &.glide__slide--clone {
    order: 1;
    opacity: 0;
    visibility: hidden;
  }
  &.glide__slide--active ~ .glide__slide--clone {
    order: 10;
    opacity: 1;
    visibility: unset;
  }
}

.filter-color-content {
  margin: 0 -3px;
}

.color {
  padding: 0 3px;
  max-width: 42px;
}

@media (max-width: 480px) {
  .filters .filter .filter-title span {
    font-size: 10px;
  }

  .filters
    .filter
    .filter-content
    .filter-relation-content
    .relation-section
    span {
    font-size: 11px;
    font-weight: 500;
    color: #5e6770;
  }
}
</style>

<style>
.box .sf-filter__color {
  height: 36px;
  width: 36px;
}

.box .sf-color:hover {
  transform: scale(1);
}

.color .sf-filter label.sf-checkbox__container {
  position: relative;
  pointer-events: none;
}

.color .sf-checkbox {
  padding: 5px;
  pointer-events: auto;
  border: 1px solid transparent;
}

.color .sf-checkbox.active {
  border: 1px solid #222a24;
}

.color .sf-filter label.sf-checkbox__container .sf-checkbox__checkmark {
  position: absolute;
  left: 0;
}

.color .sf-filter__color {
  margin: 0;
  width: 24px;
  height: 24px;
}

.color .sf-checkbox__message {
  margin: 0;
}

.color .sf-filter__label,
.color .sf-filter__count {
  position: absolute;
}
</style>
